
<template>
  <div id="DetailsIncidents">
    <v-card rounded v-if="loadItem" class="pa-3">
      <v-card-text>
        <v-progress-linear v-if="loadItem" color="primary" indeterminate/>
        <p v-if="loadItem" class="text-center">{{$t('general.loading')}}</p>
      </v-card-text>
    </v-card>
    <v-card rounded v-else>
      <v-row no-gutters dense class="pa-4">
        <v-col cols="6">
          <v-card
            class="pa-1 mr-4"
            flat>
            <v-card-text>
              <h3 class="mb-4 primary--text text-uppercase">#{{incident.inspection.consecutive_number}} - {{incident.inspection && incident.inspection.name ? incident.inspection.name : '--'}}</h3>
              <v-row dense no-gutters>
                <v-col cols="6">
                  <h4 class="mb-3"><span class="primary--text">Inspector:</span>
                    {{incident && incident.inspection && incident.inspection.user && incident.inspection.user.name  && incident.inspection.user.last_name ?
                      incident.inspection.user.name + ' ' + incident.inspection.user.last_name : '--'}}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{$t('general.operator')}}:</span>
                    {{incident && incident.inspection && incident.inspection.current_operator ? incident.inspection.current_operator : '--'}}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{$t('general.site')}}:</span>
                    {{ incident && incident.inspection && incident.inspection.site && incident.inspection.site.name ? incident.inspection.site.name : '--' }}
                  </h4>
                </v-col>
                <v-col cols="6">
                  <h4 class="mb-3"><span class="primary--text">{{$t('general.duration')}}:</span>
                    {{incident && incident.inspection && incident.inspection.duration ? incident.inspection.duration : '--'}}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{$t('general.created')}}:</span>
                    {{incident && incident.inspection && incident.inspection.created_at ? incident.inspection.created_at : '--'}}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{$t('inspections.transit')}}:</span>
                    {{incident && incident.inspection && incident.inspection.transit ? incident.inspection.transit : '--'}}
                  </h4>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="pa-1 ml-4 mt-6"
            outlined
            flat>
            <v-card-text v-if="incident && incident.inspection && incident.inspection.truck !== null">
              <h3 class="mb-3"><span class="primary--text text-uppercase">{{$t('monitoring.trasnport_unit')}}</span></h3>
              <h4 class="mb-3"><span class="primary--text">VIN:</span>
                {{incident.inspection.truck.vin_number ? incident.inspection.truck.vin_number : '--'}}
              </h4>
              <h4 class="mb-3"><span class="primary--text">{{$t('monitoring.unit_type')}}:</span>
                {{incident.inspection.truck.unit_types && incident.inspection.truck.unit_types.name ?
                  incident.inspection.truck.unit_types.name : '--'
                }}
              </h4>
              <h4 class="mb-3"><span class="primary--text">{{$t('monitoring.numberEconomic')}}:</span>
                {{incident.inspection.truck.unit_number ? incident.inspection.truck.unit_number : '--'}}
              </h4>
              <h4 class="mb-3"><span class="primary--text">{{$t('monitoring.plaque')}}: </span>
                <span v-if="incident.inspection.truck.plates.length < 0"> {{$t('units.noPlates')}}</span>
                <span v-if="incident.inspection.truck.plates.length > 0">
                  <v-chip small v-for="plate in incident.inspection.truck.plates" :key="plate.id"
                  class="mx-1 pr-0" color="secondary">
                  {{plate.plate_number}}
                  <v-chip small class="ml-1" color="primary">{{plate.country["alpha_code-3"]}}</v-chip>
                </v-chip>
                </span>
              </h4>
            </v-card-text>
            <v-card-text v-if="incident && incident.inspection && incident.inspection.truck === null && incident.inspection.container !== null">
              <h3 class="mb-3"><span class="primary--text text-uppercase">{{$t('monitoring.trasnport_unit')}}</span></h3>
              <v-row no-gutters dense>
                <v-col cols="6">
                  <h4 class="mb-3"><span class="primary--text">VIN:</span>
                    {{incident.inspection.container.vin_number ? incident.inspection.container.vin_number : '--'}}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{$t('monitoring.unit_type')}}:</span>
                    {{incident.inspection.container.unit_types && incident.inspection.container.unit_types.name ?
                      incident.inspection.container.unit_types.name : '--'
                    }}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{$t('monitoring.numberEconomic')}}:</span>
                    {{incident.inspection.container.unit_number ? incident.inspection.container.unit_number : '--'}}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{$t('monitoring.plaque')}}: </span>
                    <span v-if="incident.inspection.container.plates.length < 0"> {{$t('units.noPlates')}}</span>
                    <span v-if="incident.inspection.container.plates.length > 0">
                      <v-chip small v-for="plate in incident.inspection.container.plates" :key="plate.id"
                      class="mx-1 pr-0" color="secondary">
                      {{plate.plate_number}}
                      <v-chip small class="ml-1" color="primary">{{plate.country["alpha_code-3"]}}</v-chip>
                    </v-chip>
                    </span>
                  </h4>
                </v-col>
                <v-col cols="6">
                  <h4 class="mb-3"><span class="primary--text">{{ $t('inspections.charge') }}: </span>
                    {{ incident.inspection.loaded ? incident.inspection.loaded : '--' }}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{ $t('inspections.stamp') }} 1: </span>
                    {{ incident.inspection.seal_1 ? incident.inspection.seal_1 : '--' }}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{ $t('inspections.stamp') }} 2: </span>
                    {{ incident.inspection.seal_2 ? incident.inspection.seal_2 : '--' }}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{ $t('inspections.stamp') }} 3: </span>
                    {{ incident.inspection.seal_3 ? incident.inspection.seal_3 : '--' }}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{ $t('inspections.barrier') }}: </span>
                    {{ incident.inspection.seal_barrier ? incident.inspection.seal_barrier : '--' }}
                  </h4>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-else-if="incident && incident.inspection && incident.inspection.truck === null && incident.inspection.container === null">
              <h3 class="mb-3"><span class="primary--text text-uppercase">{{$t('monitoring.trasnport_unit')}}</span></h3>
              <h4 class="mb-3">{{$t('general.noData')}}</h4>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12"><v-divider class="my-6"/></v-col>
        <v-col cols="6">
          <h3 class="primary--text">{{$t('monitoring.damageGallery')}}</h3>
        </v-col>
        <v-col cols="6">
          <v-row no-gutters justify="end" align="center">
            <v-btn color="primary" @click="downloadGallery" :loading="loadButton" :disabled="loadButton" depressed>
              {{$t('monitoring.downloadPhotos')}}
              <v-icon small class="ml-2">mdi-download</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <!-- Galeria de daños -->
        <v-col cols="12" class="mt-5" v-if="loadByID">
          <v-row no-gutters dense align="center" justify="center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <span class="text-center primary--text ml-2">{{$t('general.loading')}}</span>
          </v-row>
        </v-col>
        <v-col class="my-5"
          v-for="(img, i) in photos" :key="i">
          <v-card class="mx-auto" max-width="344" tile v-if="photos.length > 0">
            <v-hover v-slot="{ hover }">
              <v-img :src="`data:image/jpeg/;base64,${img.img}`"
             :lazy-src="`data:image/jpeg/;base64,${img.img}`"
             height="200px">
                <v-overlay v-if="hover" absolute>
                  <v-btn small color="white" outlined @click="viewImage(img)">{{$t('inspections.viewImg')}}</v-btn>
                </v-overlay>
                <template v-slot:placeholder>
                  <v-row
                    :value="loadByID"
                    class="fill-height ma-0"
                    align="center"
                    justify="center">
                    <v-progress-circular
                      indeterminate
                      color="primary">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-hover>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :color="show && activeItem === img ? 'success' : 'primary'"
                x-small rounded depressed
                @click="show && activeItem === img ?  inactive(img) : active(img)">
                {{ show && activeItem === img ? $t('general.hideDetail') : $t('general.seeDetail') }}
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card class="mx-auto" width="344" tile outlined v-if="show && activeItem === img">
            <v-card-text>
              <h5 class="mb-1">{{img.description}}</h5>
              <h5 class="mb-1"><span class="primary--text">{{$t('monitoring.question')}}: </span>{{img.name_questions}}</h5>
              <h5 class="primary--text mb-1">{{$t('monitoring.levelDamage')}}:
                <v-chip small :color="colorDamageLevel(img.damage_level)">{{$t(levelname)}}</v-chip>
              </h5>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog scrollable v-model="imageDialog" width="800px">
      <v-card>
        <v-card-text class="pa-0">
          <v-img :src="`data:image/jpeg/;base64,${viewItem.img}`"/>
        </v-card-text>
        <div class="pa-2">
          <v-chip small :color="viewItem.color" class="font-weight-bold mb-2">{{$t(viewItem.text)}}</v-chip>
          <p class="mb-0">
            <span class="font-weight-bold">{{ viewItem.name_questions }}</span> 
          </p>
          <p class="mb-0"> "{{ viewItem.description }}" </p>
        </div>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" depressed @click="closeImgDialog">{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'DetailsIncidents',
  data () {
    return {
      levelname: '',
      show: false,
      loadItem: true,
      // loadGallery: false,
      loadByID: false,
      loadButton: false,
      imageDialog: false,
      viewItem: {
        img: '',
        damage_level: '',
      },
      activeItem: {},
      incident: {},
      galleryID: [],
      levels: this.$constants.DAMAGE_LEVEL,
    }
  },
  computed: {
    photos () {
      let item = []
      this.galleryID.forEach(e => {
        if (e.issues && e.issues.data.length > 0) {
          e.issues.data.forEach(a => item.push(a))
        }
      })
      return item
    }
  },
  created () {
    if (this.$route.params.id) {
      this.$store.dispatch('incidents/getIncidentById', {
        event: {
          context: this,
          id: this.$route.params.id
        }
      })
    }
    if (this.incident !== null) {
      this.getGallery()
    }
  },
   methods: {
    viewImage (item) {
      const scaleItem = this.levels.find(e => e.value === item.damage_level)
      this.viewItem = Object.assign({
        ...item,
        color: scaleItem ? scaleItem.color : 'default',
        text: scaleItem ? scaleItem.text : 'general.none',
      })
      this.imageDialog = true
    },
    closeImgDialog() {
      this.imageDialog = false
    },
    getGallery () {
      this.loadByID = true
      this.$store.dispatch('incidents/getGallery', {
        event: {
          context: this,
          inspectionsById: this.$route.params.id,
          page: 1,
          perPage: -1
        }
      })
      // this.loadGallery = true
      // this.$store.dispatch('incidents/getGalleryReport', {
      //   event: {
      //     context: this,
      //     id: [this.$route.params.id],
      //     type: 'json',
      //     perPage: -1,
      //     page: 1
      //   }
      // })
    },
    downloadGallery () {
      this.loadButton = true
      this.$store.dispatch('incidents/getGalleryReport', {
        event: {
          context: this,
          id: [this.$route.params.id],
          type: 'download',
          perPage: -1,
          page: 1
        }
      })
    },
    /** Activa el deslizamiento de detalles de la card de la evidencia que fue seleccionado */
    active (item) {
      this.activeItem = this.photos.find(e => e === item)
      if (this.activeItem) {
        this.show = true
      }
    },
    /** Desactiva y devuelve a su posicion la card de la galeria de daño */
    inactive (item) {
      this.activeItem = this.photos.find(e => e === item)
      if (this.activeItem) {
        this.show = false
      }
    },
    /**
     * Valida y define el color correspondiente del nivel de daño
     */
    colorDamageLevel (item) {
      let color = this.levels.find(e => e.value === item)
      this.levelname = color ? color.text : 'general.none'
      return color ? color.color : 'default'
    }
  }
}
</script>
<style>
</style>